module.exports = __webpack_public_path__ + "media/meow_1.4265a38d.wav";